import React from "react";

import { SearchItemProps } from "./search-item.types";
import styles from "./search-item.module.scss";

const SearchItem: React.FC<SearchItemProps> = (props: SearchItemProps) => {
  return (
    <div className={styles.searchItemWrapper} onClick={(): void => props.handleChangeChat(props.chatData.id)}>
      <div className={styles.information}>
        <div className={styles.informationContact}>
          <div className={styles.name}>{props.chatData.name}</div>
          <div className={styles.phone}>{props.chatData.opponentPhone ?? ""}</div>
        </div>
      </div>
    </div>
  );
};

export default SearchItem;
